module.exports = __webpack_public_path__ + "static/media/top-bar-backing.e367e6e1.png";